"use client";

import { motion } from "framer-motion";

interface AchievementsSectionProps {
  achievements: {
    title: string;
    items: Array<{
      title: string;
      value: string;
      unit: string;
    }>;
  };
}

const AchievementsSection = ({ achievements }: AchievementsSectionProps) => {
  if (!achievements?.items?.length) return null;

  return (
    <section className="bg-tertiary py-[3rem] md:py-[4rem] px-[1rem] md:px-[2rem] w-full">
      <div className="mx-auto max-w-[120rem] w-full">
        <motion.h2
          initial={{ opacity: 0, y: 8 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.45 }}
          className="mx-auto max-w-[60rem] text-[2rem] sm:text-[2.5rem] lg:text-[3.25rem] leading-[1.3] font-bold text-white text-center mb-[2rem] md:mb-[3rem]"
        >
          {achievements.title}
        </motion.h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-[1.25rem] md:gap-[1.5rem]">
          {achievements.items.map((item, index) => (
            <motion.article
              key={index}
              initial={{ opacity: 0, y: 6 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{
                duration: 0.45,
                delay: Math.min(index * 0.025, 0.15),
              }}
              className="grid grid-rows-[minmax(3.75rem,auto)_1fr_auto] min-w-0 rounded-[1rem] border-t-[3px] border-secondary bg-white p-[1.75rem] md:p-[2rem] shadow-sm"
            >
              <h3 className="text-[1.1rem] md:text-[1.25rem] leading-[1.5] font-semibold text-tertiary break-words">
                {item.title}
              </h3>
              <p className="mt-[1.25rem] mb-[0.75rem] text-[clamp(1.8rem,2.2vw,2.75rem)] leading-[1.2] font-bold tracking-tight text-primary tabular-nums break-words">
                {item.value}
              </p>
              <p className="text-[1rem] md:text-[1.125rem] leading-[1.5] text-[#575757]">
                {item.unit}
              </p>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AchievementsSection;
